import { Text } from '@moia-dev/pace-web'
import { jiraIssueUrl } from './jira'

export type AnnotationJiraLinkProps = {
  issueKey: string
  size?: 'sm' | 'md'
}

/**
 * The Jira issue key as a link to the ticket, opening in a new tab.
 *
 * Shared by the map popup, the resolved badge and the triage table so a ticket
 * reads and opens the same way everywhere.
 */
export const AnnotationJiraLink = ({
  issueKey,
  size = 'md',
}: AnnotationJiraLinkProps) => (
  <a
    href={jiraIssueUrl(issueKey)}
    target="_blank"
    rel="noopener noreferrer"
    css={theme => ({
      color: theme.semantic.ColorAccentDefault,
      textDecoration: 'none',
    })}
  >
    <Text size={size} css={{ color: 'inherit' }}>
      {issueKey}
    </Text>
  </a>
)
